import { useState } from 'react';

import { TTableRow, TTableSortOrder } from 'common/types/table';
import { ITableSettings } from 'common/interfaces/tables';

const DEFAULT_TABLE_SETTINGS: ITableSettings = {
    orderBy: '',
    order: 'asc',
    page: 0,
    rowsPerPage: 25,
};

export const useTable = (settings?: Pick<ITableSettings, 'rowsPerPage'>) => {
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const [tableSettings, setTableSettings] = useState({
        ...DEFAULT_TABLE_SETTINGS,
        ...settings,
    });

    const resetSelectedRows = () => setSelectedRows([]);

    const handleSelectAllClick = (
        e: React.ChangeEvent<HTMLInputElement>,
        tableRows: TTableRow[]
    ) => {
        if (!e.target.checked) return resetSelectedRows();

        const newSelectedRows = tableRows.map((row) => row.id);
        setSelectedRows(newSelectedRows);
    };

    const handleCheckboxClick = (rowId: string) => {
        const selectedRowIndex = selectedRows.indexOf(rowId);

        if (selectedRowIndex === -1) {
            return setSelectedRows([...selectedRows, rowId]);
        }

        const newSelectedRows = [...selectedRows];

        newSelectedRows.splice(selectedRowIndex, 1);

        setSelectedRows(newSelectedRows);
    };

    const isRowSelected = (rowId: string) => selectedRows.indexOf(rowId) !== -1;

    const setOrder = (order: TTableSortOrder, orderBy: string) => {
        setTableSettings({
            ...tableSettings,
            order,
            orderBy,
        });
    };

    const setPage = (page: number) => {
        setTableSettings({
            ...tableSettings,
            page,
        });
    };

    const setRowsPerPage = (rowsPerPage: number) => {
        setTableSettings({
            ...tableSettings,
            rowsPerPage,
        });
    };

    return {
        selectedRows,
        selectedRowAmount: selectedRows.length,
        ...tableSettings,
        setOrder,
        setPage,
        setRowsPerPage,
        setSelectedRows,
        resetSelectedRows,
        handleSelectAllClick,
        handleCheckboxClick,
        isRowSelected,
    };
};
